import React from 'react';
import { StepsProps } from 'antd';

import { StyledAntdSteps } from './style';

const CVSteps = (props: StepsProps & {
  children?: React.ReactNode
}): JSX.Element => (
  <StyledAntdSteps {...props} />
);

CVSteps.Step = StyledAntdSteps.Step;

export default CVSteps;
